import { Link } from 'react-router-dom';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="site-footer" id="contact">
      <div className="site-footer-container">
        <div className="site-footer-brand">
          <h3>Ummah Elite Academy</h3>
          <p>
            Formations digitales pour construire une activite en ligne solide,
            ethique et durable.
          </p>
        </div>

        <div className="site-footer-column">
          <h4>Navigation</h4>
          <a href="/#apropos">A propos</a>
          <a href="/#formations">Formations</a>
          <a href="/#formations-avenir">Formations a venir</a>
        </div>

        <div className="site-footer-column">
          <h4>Contact</h4>
          <a href="mailto:eliteummah@gmail.com">eliteummah@gmail.com</a>
          <p>France</p>
        </div>

        <div className="site-footer-column">
          <h4>Legal</h4>
          <Link to="/mentions-legales">Mentions legales</Link>
          <Link to="/mentions-legales#donnees-personnelles">Donnees personnelles</Link>
          <Link to="/mentions-legales#cookies">Cookies</Link>
        </div>
      </div>

      <div className="site-footer-bottom">
        <p>© {new Date().getFullYear()} Ummah Elite Academy. Tous droits reserves.</p>
      </div>
    </footer>
  );
}

export default Footer;
